import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FacilitiesForDisableIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FacilitiesForDisableIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.72365 14.9688C6.75438 14.9688 5.96583 15.7573 5.96583 16.7266C5.96583 17.6959 6.75438 18.4844 7.72365 18.4844C8.69291 18.4844 9.48147 17.6959 9.48147 16.7266C9.48147 15.7573 8.69291 14.9688 7.72365 14.9688ZM7.72365 17.3125C7.40056 17.3125 7.13771 17.0497 7.13771 16.7266C7.13771 16.4035 7.40056 16.1406 7.72365 16.1406C8.04674 16.1406 8.30959 16.4035 8.30959 16.7266C8.30959 17.0497 8.04674 17.3125 7.72365 17.3125Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.8643 19.2657H20.0246C19.8218 18.5514 19.2582 17.9879 18.544 17.785V13.211C18.544 12.2417 17.7554 11.4531 16.7862 11.4531H15.419V9.50001H16.3955C16.7191 9.50001 16.9815 9.23767 16.9815 8.91407V6.57032C16.9815 6.24673 16.7191 5.98438 16.3955 5.98438H8.30959V4.14844C8.30959 2.96379 7.3458 2 6.16115 2H4.98927C4.66568 2 4.40333 2.26234 4.40333 2.58594C4.40333 2.90954 4.66567 3.17188 4.98927 3.17188H6.16115C6.69963 3.17188 7.13771 3.60997 7.13771 4.14844V11.4859C4.50466 11.7783 2.4502 14.0169 2.4502 16.7266C2.4502 19.6344 4.81587 22 7.72365 22C10.6314 22 12.9971 19.6344 12.9971 16.7266C12.9971 16.1105 12.8905 15.5188 12.6955 14.9688H17.3721V17.785C16.4714 18.0408 15.8096 18.8701 15.8096 19.8516C15.8096 21.0362 16.7734 22 17.958 22C18.9396 22 19.7688 21.3382 20.0246 20.4375H21.8643C22.1879 20.4375 22.4502 20.1752 22.4502 19.8516C22.4502 19.528 22.1879 19.2657 21.8643 19.2657ZM8.30959 7.15626H15.8096V8.32814H8.30959V7.15626ZM8.30959 9.50001H14.2471V11.4531H8.30959V9.50001ZM7.72365 20.8282C5.46204 20.8282 3.62208 18.9882 3.62208 16.7266C3.62208 14.465 5.46204 12.625 7.72365 12.625C9.98526 12.625 11.8252 14.465 11.8252 16.7266C11.8252 18.9882 9.98526 20.8282 7.72365 20.8282ZM12.1062 13.7969C11.8094 13.3544 11.4474 12.9592 11.0341 12.625H16.7862C17.1093 12.625 17.3721 12.8879 17.3721 13.2109V13.7969H12.1062ZM17.958 20.8282C17.4196 20.8282 16.9815 20.3901 16.9815 19.8516C16.9815 19.3131 17.4196 18.875 17.958 18.875C18.4965 18.875 18.9346 19.3131 18.9346 19.8516C18.9346 20.3901 18.4965 20.8282 17.958 20.8282Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FacilitiesForDisableIcon;
